import { connect } from 'react-redux';

import EventInfo from './eventInfo';

const mapStateToProps = state => ({
  section: state.app.pageData.section,
  eventType: state.app.pageData.eventType,
  eventPrices: state.app.pageData.eventPrices,
  gomusTourCategory: state.app.pageData.gomusTourCategory,
  gomusTourCategoryOverride: state.app.pageData.gomusTourCategoryOverride,
  location: state.app.pageData.location,
  gomusLanguage: state.app.pageData.gomusLanguage,
  gomusLanguages: state.app.pageData.gomusLanguages,
  gomusEventLanguages: state.app.pageData.gomusEvent?.gomusLanguages,
  gomusEventCategory: state.app.pageData.gomusEvent?.gomusEventCategory,
  gomusEventCategoryOverride: state.app.pageData.gomusEvent?.gomusEventCategoryOverride,
  gomusLocation: state.app.pageData.gomusLocationOverride
    ? state.app.pageData.gomusLocationOverride
    : state.app.pageData.gomusLocation,
  duration: state.app.pageData.duration,
  seatsMax: state.app.pageData.seatsMax,
  additionalInformation: state.app.pageData.additionalInformation
});

export default connect(mapStateToProps)(EventInfo);
